import { render, staticRenderFns } from "./DemonstrativoConceitoFrequencia.vue?vue&type=template&id=1ed8fc5a&"
import script from "./DemonstrativoConceitoFrequencia.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoConceitoFrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports